import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { Dayjs } from "dayjs"
import {
  IFile,
  IPaymentRecruiters,
  IPersonalInformation,
  IResultateInput,
} from "../../../../model/create/CreateInterwiew"
import { ISelect } from "../../../../model/create/СreateAvailableSchedule"

export interface IInterviewGroup {
  data: IInterviewFullRow[]
}

export interface IInterviewGroup {
  data: IInterviewFullRow[]
}

const interviewGroupState: IInterviewGroup = {
  data: [],
}

export interface IInterviewFullRow {
  interviewDateTime: ISelect | null
  created: string | Dayjs | null
  department: ISelect | null
  fullNameCandidates: string | null
  graphType: ISelect | null
  id: any
  statusSelect: ISelect[]
  interviewType: ISelect | null
  interviewer: {
    id: string | null
    name: string | null
  } | null
  isConfirmed: boolean | null
  line: ISelect | null
  isGroup: boolean | null
  massRecruiter: ISelect | null
  training: ISelect | null
  project: ISelect | null
  schedule: {
    id: number | null
    endDate: null
    pattern: null
    startDate: null
    type: ISelect | null
  }
  scheduleType: string | null
  status: ISelect | null
  // workDays: {
  //   endDate: Dayjs | null
  //   startDate: Dayjs | null
  // }
  workDays: ISelect
  resultate: IResultateInput
  personalInformation: IPersonalInformation
  timeSlots: {
    date: null
    endDate: null
    id: null
    startDate: null
  }
  paymentRecruiters: IPaymentRecruiters
  // interviewInformation: IInterviewInformation
}

export interface IInterviewMode {
  mode: "edit" | "create" | null | undefined
}

const interviewRowState: IInterviewFullRow = {
  created: null,
  department: null,
  fullNameCandidates: null,
  graphType: null,
  id: null,
  interviewDateTime: null,
  interviewType: { name: null, id: null },
  interviewer: { name: null, id: null },
  isConfirmed: null,
  isGroup: null,
  line: { name: null, id: null },
  massRecruiter: { name: null, id: null },
  training: { name: null, id: null },
  project: null,
  schedule: {
    id: null,
    endDate: null,
    pattern: null,
    startDate: null,
    type: {
      id: null,
      name: null,
    },
  },
  scheduleType: null,
  status: { name: null, id: null },
  // workDays: {
  //   endDate: null,
  //   startDate: null,
  // },
  workDays: { name: null, id: null },
  statusSelect: [],
  resultate: {
    status: null,
    statusSelect: [],
    eliminationStage: null,
    eliminationReason: null,
    eliminationDate: null,
    printingSpeed: null,
    grammar: null,
    interviewResults: null,
    trainingResults: {
      startDate: null,
      endDate: null,
      result: null,
    },
    certificationResults: {
      iqs: null,
      testResults: null,
      testResultPercent: null,
    },
    massRecruiter: { name: null, id: null },
    training: { name: null, id: null },
  },
  personalInformation: {
    fullName: null,
    dateOfBirth: null,
    mobilePhone: null,
    city: null,
    email: null,
    resume: null,
    telegram: null,
    file: [],
    delFile: [],
    newFile: [],
  },
  timeSlots: {
    date: null,
    endDate: null,
    id: null,
    startDate: null,
  },
  paymentRecruiters: {
    lineCame: null,
    lineCameDate: null,
    registered: null,
    registeredDate: null,
    trainingCompleted: null,
    trainingCompletedDate: null,
  },
}

const interviewGroupSlice = createSlice({
  name: "InterviewGroup",
  initialState: interviewGroupState,
  reducers: {
    setInterviewGroupState: (state, action: PayloadAction<IInterviewGroup>) => {
      state.data = action.payload.data
      // state.files = action.payload.files
    },
  },
})

const interviewRowSlice = createSlice({
  name: "InterviewRow",
  initialState: interviewRowState,
  reducers: {
    setInterviewRowState: (state, action: PayloadAction<IInterviewFullRow>) => {
      return {
        ...state,
        created: action.payload.created,
        department: action.payload.department,
        fullNameCandidates: action.payload.fullNameCandidates,
        graphType: action.payload.graphType,
        id: action.payload.id,
        interviewDateTime: action.payload.interviewDateTime,
        interviewType: action.payload.interviewType,
        interviewer: action.payload.interviewer,
        isConfirmed: action.payload.isConfirmed,
        isGroup: action.payload.isGroup,
        line: action.payload.line,
        massRecruiter: action.payload.massRecruiter,
        training: action.payload.training,
        project: action.payload.project,
        schedule: action.payload.schedule,
        scheduleType: action.payload.scheduleType,
        status: action.payload.status,
        statusSelect: action.payload.statusSelect,
        // workDays: {
        //   ...state.workDays,
        //   endDate: action.payload.workDays?.endDate,
        //   startDate: action.payload.workDays?.startDate,
        // },
        workDays: action.payload.workDays,
        resultate: {
          ...state.resultate,
          // status: action.payload.resultate?.status,
          eliminationStage: action.payload.resultate?.eliminationStage,
          eliminationReason: action.payload.resultate?.eliminationReason,
          eliminationDate: action.payload.resultate?.eliminationDate,
          printingSpeed: action.payload.resultate?.printingSpeed,
          grammar: action.payload.resultate?.grammar,
          interviewResults: action.payload.resultate?.interviewResults,
          trainingResults: {
            ...state.resultate.trainingResults,
            startDate: action.payload.resultate?.trainingResults?.startDate,
            endDate: action.payload.resultate?.trainingResults?.endDate,
            result: action.payload.resultate?.trainingResults?.result,
          },
          certificationResults: {
            ...state.resultate.certificationResults,
            iqs: action.payload.resultate?.certificationResults?.iqs,
            testResults:
              action.payload.resultate?.certificationResults?.testResults,
            testResultPercent:
              action.payload.resultate?.certificationResults?.testResultPercent,
          },
          massRecruiter: action.payload.resultate?.massRecruiter,
        },
        personalInformation: {
          ...state.personalInformation,
          fullName: action.payload.personalInformation?.fullName,
          dateOfBirth: action.payload.personalInformation?.dateOfBirth,
          mobilePhone: action.payload.personalInformation?.mobilePhone,
          city: action.payload.personalInformation?.city,
          email: action.payload.personalInformation?.email,
          resume: action.payload.personalInformation?.resume,
          telegram: action.payload.personalInformation?.telegram,
          file: Array.isArray(action.payload.personalInformation?.file)
            ? action.payload.personalInformation?.file
            : [],
          delFile: Array.isArray(action.payload.personalInformation?.delFile)
            ? action.payload.personalInformation?.delFile
            : [],
          newFile: Array.isArray(action.payload.personalInformation?.newFile)
            ? action.payload.personalInformation?.newFile
            : [],
        },

        timeSlots: {
          ...state.timeSlots,
          date: action.payload.timeSlots?.date,
          endDate: action.payload.timeSlots?.endDate,
          id: action.payload.timeSlots?.id,
          startDate: action.payload.timeSlots?.startDate,
        },
        paymentRecruiters: {
          ...state.paymentRecruiters,
          lineCame: action.payload.paymentRecruiters?.lineCame,
          lineCameDate: action.payload.paymentRecruiters?.lineCameDate,
          registered: action.payload.paymentRecruiters?.registered,
          registeredDate: action.payload.paymentRecruiters?.registeredDate,
          trainingCompleted:
            action.payload.paymentRecruiters?.trainingCompleted,
          trainingCompletedDate:
            action.payload.paymentRecruiters?.trainingCompletedDate,
        },
      }
    },
    addFiles: (state, action: PayloadAction<IFile[]>) => {
      state.personalInformation.file = [
        ...state.personalInformation.file,
        ...action.payload,
      ]
    },
    delFiles: (state, action: PayloadAction<IFile[]>) => {
      state.personalInformation.delFile = [
        ...state.personalInformation.delFile,
        ...action.payload,
      ]
    },

    newFiles: (state, action: PayloadAction<IFile[]>) => {
      state.personalInformation.newFile = [
        ...state.personalInformation.newFile,
        ...action.payload,
      ]
    },
    removeFile: (state, action: PayloadAction<IFile>) => {
      state.personalInformation.file = state.personalInformation.file.filter(
        (file) => file.link !== action.payload.link,
      )
    },
  },
})

const interviewModeState: IInterviewMode = {
  mode: null,
}

const interviewModeSlice = createSlice({
  name: "interviewMode",
  initialState: interviewModeState,
  reducers: {
    setInterviewModeState: (state, action: PayloadAction<IInterviewMode>) => {
      state.mode = action.payload.mode
    },
  },
})

const interviewDateState: any = {
  workDaysStartDate: null,
}

export interface IInterviewDate {
  trainingResultsStartDate: Dayjs | null
  trainingResultsEndDate: Dayjs | null
  dateOfBirth: Dayjs | null
  workDaysStartDate: Dayjs | null
  workDaysEndDate: Dayjs | null
  lineCameDate: Dayjs | null
  registeredDate: Dayjs | null
  trainingCompletedDate: Dayjs | null
  eliminationDate: Dayjs | null
}
const interviewDateSlice = createSlice({
  name: "interviewDate",
  initialState: interviewDateState,
  reducers: {
    setInterviewDateState: (state, action: PayloadAction<IInterviewDate>) => {
      state.trainingResultsStartDate = action.payload.trainingResultsStartDate
      state.trainingResultsEndDate = action.payload.trainingResultsEndDate
      state.dateOfBirth = action.payload.dateOfBirth
      state.workDaysStartDate = action.payload.workDaysStartDate
      state.workDaysEndDate = action.payload.workDaysEndDate
      state.lineCameDate = action.payload.lineCameDate
      state.registeredDate = action.payload.registeredDate
      state.trainingCompletedDate = action.payload.trainingCompletedDate
      state.eliminationDate = action.payload.eliminationDate
    },
  },
})

export const interviewGroupReducer = interviewGroupSlice.reducer
export const interviewRowReducer = interviewRowSlice.reducer
export const interviewModeReducer = interviewModeSlice.reducer
export const interviewDateReducer = interviewDateSlice.reducer

export const { setInterviewGroupState } = interviewGroupSlice.actions
export const {
  setInterviewRowState,
  addFiles,
  removeFile,
  delFiles,
  newFiles,
} = interviewRowSlice.actions
export const { setInterviewModeState } = interviewModeSlice.actions
export const { setInterviewDateState } = interviewDateSlice.actions
